import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
export const OPEN_REPLACE_PINNED_ENGAGEMENT_MODAL_HANDLER = {
  topic: TOPIC_NAMES.OPEN_REPLACE_PINNED_ENGAGEMENT_MODAL,
  type: 'MODAL',
  componentLoader: () => import('../wrappers/OpenReplacePinnedEngagementModal')
};